import {
  updateProduct,
  queryProductInfo,
  queryRelatedAttrValue,
  queryGtRelatedAttrValue,
  updateProductStatus,
  querySkuChannelList
} from "@/graphql/Products.gql";
import {
  CreateProduct,
  getBrand,
  // pim 2.0
  queryConnCategoryList,
  queryConnAttrList,
  queryProductChannelList,
  publishProduct,
  saveConnSkuList,
  queryOnlineShopByChannel,
  queryDataDictionaryListLang,
  queryConnBrandList,
  saveConnProduct,
  getConnExtendParams,
  querySkuChannelPage,
  uploadChannelImage,
  getProductChannel,
  updateSkuStatus,
  queryOpsLogApi
} from "@/graphql/CreateProduct.gql";
import { BatchEditSku } from "@/graphql/BatchEditSku.gql";
import { resRest } from "@root/lib/utils";
import router from "@root/router";

export default {
  namespaced: true,
  state: {
    productInfo: {
      skus: []
    },
    skuAttrData: [],
    familySkuList: [],
    familySpuList: [],
    channelProduct: {},
    channelSkuList: []
  },
  getters: {
    // 记录原始商品价格
    originProductPrice(state: any) {
      let { productPrice = "", salePrice = "" } = state.productInfo;
      let result = {
        productPrice,
        salePrice
      };
      return result;
    },
    propertiesData(state: any) {
      let {
        productCode = "",
        productNo = "",
        productName = "",
        barcode = "",
        brandCode = "",
        productType = "",
        productPrice = "",
        salePrice = "",
        extCode = "",
        orgCode = "default",
        categoryCodeList = [],
        sort = "",
        status
      } = state.productInfo;
      let categoryCodeListFilter = categoryCodeList.map((item: any) => {
        const name = item.categoryNamePath.split(">");
        return { ...item, categoryName: name[name.length - 1] };
      });
      return {
        productCode,
        productNo,
        productName,
        barcode,
        brandCode,
        productType,
        productPrice,
        salePrice,
        extCode,
        orgCode,
        categoryCodeList: categoryCodeListFilter,
        sort,
        status
      };
    },
    mediaData(state: any) {
      let { mobileMediaLink, mediaLink } = state.productInfo;
      return {
        mobileMediaLink: (mobileMediaLink && mobileMediaLink.split(",")) || [],
        mediaLink: (mediaLink && mediaLink.split(",")) || []
      };
    },
    attrList(state: any) {
      return state.skuAttrData.length
        ? state.skuAttrData[0].relatedAttrValueList
        : [];
    },
    productDescription(state: any) {
      let { extendParams } = state.productInfo;
      return {
        production: state.productInfo.productDescription || "",
        extendParams: extendParams ? JSON.parse(extendParams) : {}
      };
    },
    skuList(state: any) {
      let skulist = state.productInfo.skus.map((item: any) => {
        const filterData = state.skuAttrData.find(
          (cell: any) => cell.relationCode === item.skuCode
        );
        let valueData: any = {};
        if (filterData) {
          filterData.relatedAttrValueList.forEach((item: any) => {
            if (item.attrValueType === 1) {
              valueData[item.attrCode] = [
                {
                  attrValue: item.attrValueList.map((cell: any) => {
                    return cell.attrValue;
                  })
                }
              ];
            } else {
              valueData[item.attrCode] = item.attrValueList.map((cell: any) => {
                return { attrValue: cell.attrValue };
              });
            }
          });
        }
        return {
          ...item,
          relatedAttrValue: valueData,
          statusTemp: item.status === 1 ? true : false
        };
      });
      // console.log(skulist, "skuList state");
      return skulist;
    }
  },
  actions: {
    async updateProduct({ rootState, state, commit }: any, data: any) {
      await rootState.gql.mutate({
        mutation: updateProduct,
        variables: {
          input: {
            ...data,
            channel: localStorage.getItem("channel")
          }
        }
      });
    },
    async batchEditSku({ rootState, state, commit }: any, data: any) {
      await rootState.gql.mutate({
        mutation: BatchEditSku,
        variables: {
          input: data.map(
            item =>
              (item = {
                ...item,
                channel: localStorage.getItem("channel"),
                orgCode: localStorage.getItem("org") || "default"
              })
          )
        }
      });
    },

    async createProduct({ rootState, state, commit }: any, data: any) {
      await rootState.gql.mutate({
        mutation: CreateProduct,
        variables: {
          input: {
            ...data,
            channel: localStorage.getItem("channel"),
            orgCode: localStorage.getItem("org") || "default"
          }
        }
      });
    },
    async queryProductInfo({ rootState, commit, dispatch }: any, data: any) {
      let res = await rootState.gql.query({
        query: queryProductInfo,
        variables: {
          productCode: data,
          orgCode: localStorage.getItem("org") || "default"
        }
      });
      if (
        !res.data.getProduct ||
        JSON.stringify(res.data.getProduct) === "{}"
      ) {
        router.push({ name: "Product" });
      }
      const skus = res.data.getProduct.skus || [];
      const skuCodeList = skus.map((item: any) => {
        return {
          attrType: 2,
          relationCode: item.skuCode
        };
      });
      commit("setProductInfo", res.data.getProduct);
      if (skuCodeList && skuCodeList.length) {
        await dispatch("querySkuAttrData", skuCodeList);
      }
      return res.data.getProduct.skus;
    },
    async querySkuAttrData({ rootState, commit, dispatch }: any, data: any) {
      let res = await rootState.gql.query({
        query: queryGtRelatedAttrValue,
        variables: {
          input: {
            channel: localStorage.getItem("channel"),
            orgCode: localStorage.getItem("org") || "default",
            codeList: data
          }
        }
      });
      const resultData = res.data.queryRelatedAttrValue;

      commit("setSkuAttrData", resultData);
      return resultData;
    },
    async updateProductStatus({ rootState, state, commit }: any, data: any) {
      await rootState.gql.mutate({
        mutation: updateProductStatus,
        variables: {
          input: {
            ...data
          }
        }
      });
    },
    async querySkuChannelList({ commit, state, rootState }: any, data: any) {
      let res = await rootState.gql.query({
        query: querySkuChannelList,
        variables: { skuCode: data }
      });
      return res.data.querySkuChannelList;
    },
    // pim 2.0
    async saveConnSkuList({ rootState, state, commit }: any, data: any) {
      await rootState.gql.mutate({
        mutation: saveConnSkuList,
        variables: data
      });
    },
    async saveConnProduct({ rootState, state, commit }: any, data: any) {
      await rootState.gql.mutate({
        mutation: saveConnProduct,
        variables: data
      });
    },
    async publishProduct({ rootState, state, commit }: any, data: any) {
      let res = await rootState.gql.mutate({
        mutation: publishProduct,
        variables: data
      });
      // return res.data.publishProduct.code;
    },
    async queryProductChannelList(
      { commit, state, rootState }: any,
      data: any
    ) {
      let res = await rootState.gql.query({
        query: queryProductChannelList,
        variables: data
      });
      return res.data.queryProductChannelList;
    },
    async queryOnlineShopByChannel(
      { commit, state, rootState }: any,
      data: any
    ) {
      let res = await rootState.gql.query({
        query: queryOnlineShopByChannel,
        variables: data
      });
      return res.data.queryOnlineShopByChannel;
    },
    async queryConnCategoryList({ commit, state, rootState }: any, data: any) {
      let res = await rootState.gql.query({
        query: queryConnCategoryList,
        variables: data
      });
      return res.data.queryConnCategoryList;
    },
    async queryConnAttrList({ commit, state, rootState }: any, data: any) {
      let res = await rootState.gql.query({
        query: queryConnAttrList,
        variables: data
      });
      return res.data.queryConnAttrList;
    },
    async queryDataDictionaryListLang({ commit, rootState }, { ddCode }) {
      // const tenantCode = localStorage.tenantCode
      const res = await rootState.gql.query({
        query: queryDataDictionaryListLang,
        variables: {
          input: {
            ddCode
          }
        }
      });
      return res.data.api;
    },
    async queryConnBrandList({ commit, state, rootState }: any, data: any) {
      let res = await rootState.gql.query({
        query: queryConnBrandList,
        variables: data
      });
      return res.data.api;
    },
    async getConnExtendParams({ commit, state, rootState }: any, data: any) {
      let res = await rootState.gql.query({
        query: getConnExtendParams,
        variables: data
      });
      return res.data.api;
    },
    async querySkuChannelPage({ commit, state, rootState }: any, data: any) {
      let res = await rootState.gql.query({
        query: querySkuChannelPage,
        variables: data
      });
      let dataList = resRest(res.data);
      let savedSkuMap = {};
      dataList.forEach(_ => {
        savedSkuMap[_.skuCode] = _.extendParams
          ? JSON.parse(_.extendParams)
          : {};
      });
      let list = {
        map: savedSkuMap,
        list: resRest(res.data),
        total: res.data.api.pageInfo.totalCount
      };
      return list;
    },
    async uploadChannelImage({ rootState, state, commit }: any, data: any) {
      let res = await rootState.gql.mutate({
        mutation: uploadChannelImage,
        variables: data
      });
      return res.data.uploadChannelImage.code;
    },
    async getProductChannel({ commit, state, rootState }: any, data: any) {
      let res = await rootState.gql.query({
        query: getProductChannel,
        variables: data
      });
      return res.data.api;
    },
    async updateSkuStatus({ rootState, state, commit }: any, data: any) {
      await rootState.gql.mutate({
        mutation: updateSkuStatus,
        variables: data
      });
    },
    async getBrand({ rootState, commit, dispatch }: any, data: any) {
      let res = await rootState.gql.query({
        query: getBrand,
        variables: data
      });
      return res.data.getBrand;
    },
    async queryOpsLogApi({ rootState, commit }, variables) {
      const { data } = await rootState.gql.query({
        query: queryOpsLogApi,
        variables
      });

      return { list: resRest(data), total: data.api.pageInfo.totalCount };
    }
  },
  mutations: {
    setProductInfo(state: any, data: any) {
      state.productInfo = data;
    },
    setSkuAttrData(state: any, data: any) {
      state.skuAttrData = data;
    },
    setFamilySpuList(state: any, data: any) {
      state.familySpuList = data;
    },
    setfamilySkuList(state: any, data: any) {
      state.familySkuList = data;
    },
    setChannelProduct(state: any, data: any) {
      state.channelProduct = data;
    },
    setChannelSkuList(state: any, data: any) {
      state.channelSkuList.push(data);
    },
    initChannelSpuSku(state: any, data: any) {
      state.channelProduct = {};
      state.channelSkuList = [];
    }
  }
};
